import { jsx as s } from "react/jsx-runtime";
import a from "classnames";
import { s as o } from "../../../../explorer-grid-item.module-DeIZLQ5d.js";
const t = () => /* @__PURE__ */ s("div", { className: a(o.root, o.loading, "skeleton-loader") });
export {
  t as default
};
